import styled from 'styled-components';

export const ModalContainer = styled.div`
  .modalContainer {
    background-color: white;
  }
`;

export const ListingWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  padding-left: 60px;

  @media only screen and (min-width: 996px) {
    justify-content: center;
  }
`;
